export const ACCESS_TOKEN_STORAGE_KEY = "office_map_access_token";
